export function applyLancamentoPessoa({ prev = {}, pessoa, tipo }) {
    const isPagar = tipo === 'Pagar';

    const formaId = isPagar ? pessoa?.formaFornecedorId : pessoa?.formaClienteId;
    const contaId = isPagar ? pessoa?.contaFornecedorId : pessoa?.contaClienteId;
    const centroCustoId = isPagar ? pessoa?.centroCustoFornecedorId : pessoa?.centroCustoClienteId;

    return {
        ...prev,
        Pessoa: pessoa || prev?.Pessoa,
        pessoaId: pessoa.id ?? prev?.pessoaId,
        formaId: formaId ?? prev?.formaId,
        contaId: contaId ?? prev?.contaId,
        centroCustoId: centroCustoId ?? prev?.centroCustoId,
    };
}
